import { parseIsoDateUtc } from './computeNightlySurcharge';
import type { SurchargePeriodFormValues } from './types';

export function validateSurchargePeriod(values: SurchargePeriodFormValues): Array<string> {
  const errors: Array<string> = [];

  if (values.name.trim().length < 1) {
    errors.push('Period name is required.');
  }

  const start = parseIsoDateUtc(values.startDate);
  const end = parseIsoDateUtc(values.endDate);

  if (start == null) {
    errors.push('From must be a real ISO YYYY-MM-DD date.');
  }

  if (end == null) {
    errors.push('To must be a real ISO YYYY-MM-DD date.');
  }

  if (start != null && end != null && values.startDate > values.endDate) {
    errors.push('From must be on or before To.');
  }

  if (!Number.isFinite(values.sellAud) || values.sellAud <= 0) {
    errors.push('Sell AUD must be greater than 0.');
  }

  if (values.costLocal != null && (!Number.isFinite(values.costLocal) || values.costLocal < 0)) {
    errors.push('Cost must be 0 or more.');
  }

  return errors;
}
